export type SocialMediaName = 'line' | 'facebook' | 'instagram' | 'whatsapp' | 'tiktok' | 'discord'

const generateUUID = () => {
  let d = new Date().getTime()
  const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = ((d + Math.random() * 16) % 16) | 0
    d = Math.floor(d / 16)
    // eslint-disable-next-line eqeqeq
    return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16)
  })
  return uuid
}
const gamePostMessage = (msg: string) => {
  const { isApple, isAndroid } = useDevice()
  try {
    if (isApple) {
      window.webkit.messageHandlers.FreeFire.postMessage(msg)
    } else if (isAndroid) {
      window.FreeFire.postMessage(msg)
    }
  } catch (error) {
    console.error('Please run in FreeFire')
  }
}
const gamePromise = (key: string, value?: any) => {
  const promise = new Promise(function (resolve, reject) {
    const promiseId = generateUUID()
    window.promises[promiseId] = { resolve, reject }
    const msg: any = {
      PromiseId: promiseId
    }
    if (value && typeof value === 'object') {
      const keys = Object.keys(value)
      keys.forEach((item) => {
        if (item === 'value') {
          msg[key] = value?.value
        } else {
          msg[item] = value[item]
        }
      })
    } else if (typeof value === 'string') {
      msg[key] = value || ''
    }
    console.log(msg)
    gamePostMessage(JSON.stringify(msg))
  })
  return promise
}
function inGame() {
  return window?.FreeFire || window?.webkit?.messageHandlers?.FreeFire
}
export const useGame = () => {
  return {
    inGame,
    goToSocialMedia: (name: SocialMediaName, deeplink: string, browser: string) => {
      gamePromise('GotoSocialMedia', { value: name, DeepLink: deeplink, Browser: browser })
    }
  }
}
